<template>
  <BasePromoCard
    cardClassName="mb-8 fill-height"
    :cardTitleField="this.fields.CardTitle"
    :cardContentField="this.fields.CardContent"
    :theme="this.fields.Theme"
    @promo-card-button-clicked="btnClicked"
  >
    <template v-slot:cardActions>
      {{ linkLabel }}
    </template>
  </BasePromoCard>
</template>

<script>
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import BasePromoCard from '../base-component/_BasePromoCard';
export default {
  name: 'PromoCard',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    btnClicked() {
      if (!this.isLink || typeof(window)=='undefined') {
        return;
      }
      if (this.isInternalLink) {
        if (this.linkTarget === '_blank') {
          window.open(this.linkTo);
        } else {
          this.$router.push({ path: this.linkTo });
        }
      } else {
        if (this.linkTarget === '_blank') {
          window.open(this.linkTo);
        } else {
          window.location.assign(this.linkTo);
        }
      }
    },
  },
  computed: {
    isInternalLink() {
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.linktype === 'internal'
      ) {
        return true;
      } else {
        return false;
      }
    },
    linkLabel() {
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.text !== ''
      ) {
        return this.fields.ButtonLink.value.text;
      } else {
        return '';
      }
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    isLink() {
      if (this.isSitecoreExperienceEditorOn) {
        return false;
      }
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.href !== ''
      ) {
        return true;
      }

      return false;
    },
    // SC 9 fixed the Href vs URL - now href always come nicely:
    // external: "href": "https://xxx.com.au?testing=test&testing=test",
    // media: "href": "https://xxx.com.au/-/media/iol/data/media/img/alerticon.svg"
    // internal" "href": "/xxx"
    // anchor: "href": "#anchorxxx"
    // email: "href": "mailto:test@test.com.au?subject=xxx",
    // javascript: "href": "javascript:xxx;return false;"
    linkTo() {
      if (typeof(this.fields.ButtonLink.value.href) !='undefined') {
        return this.fields.ButtonLink.value.href;
      } else {
        return '';
      }
    },
    linkTarget() {
      if (
        this.fields.ButtonLink != null &&
        this.fields.ButtonLink.value != null &&
        this.fields.ButtonLink.value.target === '_blank'
      ) {
        return '_blank';
      } else {
        return '';
      }
    },
  },
  components: {
    BasePromoCard,
  },
};
</script>
<style lang="scss" scoped></style>
